export default {
  'permission.title': '权限设置',
  'permission.create.title': '创建权限',

  'permission.permissionTree': '权限树',
  'permission.permissionDetail': '权限详情',

  'permission.field.parent_id': '父权限id',
  'permission.field.name': '权限名',
  'permission.field.foreign_name': '权限(中文名)',
  'permission.field.code': '权限代码',
  'permission.field.permission_type': '权限类型',
  'permission.field.has_email': '是否需要邮箱',
  'permission.field.has_phone': '是否需要手机号',
  'permission.field.has_pin': '是否需要pin码',
  'permission.field.has_required': '默认选中此权限',
  'permission.field.order_num': '菜单序号',
  'permission.field.notes': '备注',

  'permission.name.isRequired': '请填写权限名',
  'permission.foreign_name.isRequired': '请填写权限(中文名)',
  'permission.code.isRequired': '请填写权限代码',
  'permission.permission_type.isRequired': '请选择权限类型',

  'permission.action.addPermission': '新增权限',
  'permission.action.addSubPermission': '新增子权限',
  'permission.action.delete': '删除此权限',

  'permission.delete.promptTitle': '权限删除提示',
  'permission.delete.promptContent': '确认要删除此权限吗？',
};
